import { useEffect } from 'react';
import styled from 'styled-components';

import { useTracking } from '@xing-com/crate-communication-tracking';

import { adSlotConfig } from '../../ad-slot-config';

const AdContainer = styled.div`
  height: 90px;
`;

const AdWrapper = styled.div`
  width: 728px;
  height: 90px;
  position: relative;
  z-index: 1;
`;

declare const YLHH: any;

export const DisplayAdLoginLeaderboardIframe: React.FC = () => {
  const { id, adUnitPath, size } = adSlotConfig.Login.LeaderboardIframe;
  const { track } = useTracking();

  useEffect(() => {
    window.googletag?.cmd.push(() => {
      const slot = googletag.defineSlot(adUnitPath, size, id);

      if (slot) {
        slot.addService(googletag.pubads());
        googletag.display(slot);
      }
    });

    // @ts-expect-error yieldlove_cmd is defined by header bidding script
    window.yieldlove_cmd?.push(function () {
      YLHH?.bidder.startAuction(adUnitPath, undefined);
    });
  }, []);

  const trackClick = (): void => {
    track({
      type: 'nwt',
      event: 'visited',
      element: 'iframe_display_ad',
      eventSchema: 'basic',
      sentBy: 'welcome',
      page: 'welcome/login',
    });
  };

  return (
    <AdWrapper onClick={trackClick} data-qa="leaderboard-iframe-wrapper">
      <AdContainer id={id} />
    </AdWrapper>
  );
};
